import React from 'react'

import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";

const Map = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBBqrr-0aoCR9a2rbpzfNDH62ayxoibaV0&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ width: "100%", height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(props => (
  <GoogleMap
    defaultZoom={props.zoom}
    defaultCenter={{ lat: props.position.lat, lng: props.position.lng }}
  >
    <Marker
      position={{ lat: props.position.lat, lng: props.position.lng }}
      defaultTitle={props.title}
    />
  </GoogleMap>
));

export default Map;


// WEBPACK FOOTER //
// ./src/Map.js